import useSearchParams from './useSearchParams';

export default useSearchParams;
